// TG GRACIAS A MI SEÑOR DIOS TG TG TG TG
// CartDisplay.js
import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from './ContextVars';
import translations from './translations';
import { useNavigate } from 'react-router-dom'; // #added 20/7/25 TG

const CartDisplay = () => {
    const {cart, setCart, totalAmount, totalAmountGTQ, language} = useContext(AppContext);
    const t = (key) => translations.CartDisplay[key]?.[language] || key;
    // const [totalUSD, setTotalUSD] = useState(0); // #deleted porque le pusimos el global totalAmount TG 20/7/25 TG TG TG
    // const [totalGTQ, setTotalGTQ] = useState(0);
//   const totalUSD = cart.reduce((sum, item) => sum + parseFloat(item.price || 0), 0);
//   const totalGTQ = cart.reduce((sum, item) => sum + parseFloat(item.pricegtq || 0), 0);
    const navigate = useNavigate();

 const handleRemove = (indexToRemove) => {
  const updatedCart = cart.filter((_, index) => index !== indexToRemove);
  setCart(updatedCart);
};

  const handleCheckout = () => {
    // alert('Proceeding to checkout!');
    // Add your real checkout logic here (e.g., navigate or payment trigger)
    navigate('/checkout');
  };

/*useEffect(() => {
    const tusd = cart.reduce((sum, item) => sum + parseFloat(item.price || 0), 0);
    const tgtq = cart.reduce((sum, item) => sum + parseFloat(item.pricegtq || 0), 0)
    setTotalUSD(tusd);
    setTotalGTQ(tgtq);

    }, [cart]);*/

  return (
    <div className="cart-container">
      <h2>{t('yourCart')}</h2>
      {cart.length === 0 ? (
        <div className="cart-empty">{t('empty')}</div>
      ) : (
        <>
          <ul className="cart-items">
          {cart.map((item, index) => (
  <div key={index} className="cart-item">
    <div className="cart-item-details">
      <span className="item-name">{item.name}</span>
      <span className="item-price">${parseFloat(item.price).toFixed(2)}</span>
      <span className="item-pricegtq">Q{parseFloat(item.pricegtq).toFixed(2)}</span>
    </div>
    <button className="remove-button" onClick={() => handleRemove(index)}>✖</button>
  </div>
))}
          </ul>
          <div className="cart-total">
            <strong>{t('total')}</strong> ${totalAmount.toFixed(2)} / Q{totalAmountGTQ.toFixed(2)}
          </div>
          <button className="checkout-button" onClick={handleCheckout}>{t('checkout')}</button>
        </>
      )}
    </div>
  );
};

export default CartDisplay;
